import { SprinklesElement } from "sprinkles-js";

/**
 * Custom element for copying URLs to clipboard with visual feedback.
 *
 * @example ```
 * <clipboard-copy data-copied-text="Copied!" data-content="https://example.com/path">
 *   <button type="button" class="button">
 *     <span data-clipboard-copy-ref="copy">Copy link</span>
 *   </button>
 * </clipboard-copy>
 * ```
 *
 * Required attributes:
 * - data-copied-text: Text to display temporarily after copying
 * - data-content: The content to copy to clipboard
 *
 * Required child element:
 * - Element with data-clipboard-copy-ref="copy": Text container that will be replaced with feedback
 */
export default class ClipboardCopyElement extends SprinklesElement {
  static tagName = "clipboard-copy";
  static events = { click: { method: "handleClick" } };
  static refs = ["copy"];

  async handleClick(event) {
    event.preventDefault();

    await navigator.clipboard.writeText(this.dataset.content);

    this.showFeedback();
  }

  showFeedback() {
    const originalText = this.refs.copy.textContent;
    this.refs.copy.textContent = this.dataset.copiedText;

    setTimeout(() => {
      this.refs.copy.textContent = originalText;
    }, 2000);
  }
}
